import { Box, Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { customTheme } from '../theme';

interface Props extends TypographyProps {
  text?: string;
  boldText?: string;
  fontSize?: number;
  fontColor?: string;
  style?: React.CSSProperties;
}

export const CompoundText = ({
  text = '',
  boldText = '',
  fontSize = 14,
  fontColor = 'black',
  style,
}: Props) => {
  return (
    <Box display={'inline-flex'}>
      <Typography
        variant="regularText"
        sx={{
          fontSize: `${fontSize}px`,
          color: fontColor,
          mr: 1,
          ...style,
        }}
      >
        {text}
      </Typography>
      <Typography
        variant="boldText"
        sx={{
          fontSize: `${fontSize}px`,
          color: fontColor,
          ...style,
        }}
      >
        {boldText}
      </Typography>
    </Box>
  );
};
